export const dropdownNaturalScrollClassName =
  "dropdown-natural-scroll overflow-y-auto overscroll-contain";

export const dropdownNaturalScrollXClassName = `overflow-x-hidden ${dropdownNaturalScrollClassName}`;

export function stopDropdownScrollPropagation(
  event: { stopPropagation: () => void },
) {
  event.stopPropagation();
}
